import { Org } from "@/types/org";
import React from "react";
import { SwitchOrgsReturnType } from "../hooks/useSwitchOrgs";

interface OrgContextType{
    curOrg: Org | null;
    setCurOrg: React.Dispatch<React.SetStateAction<Org | null>>;
    orgsActions: SwitchOrgsReturnType;
  }
  
  const defaultOrgContextValue: OrgContextType = {
    curOrg: null,
    setCurOrg: () => {},
    orgsActions: [[], { addItem: () => new Promise(() => {}), updateItem: () => new Promise(() => {}), rmItem: () => new Promise(() => {}) }],
  }
  
  // 创建一个Context
  export const OrgsContext = React.createContext(defaultOrgContextValue);